import React, { useState } from "react";
import { reduxForm } from "redux-form";
import { KeyboardBackspace } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { notification } from "antd";
import { useDispatch } from "react-redux";
import styles from "../../../JobStyle.module.css";
import JobSwmsFormV3SectionRegistry from "./JobSwmsFormV3SectionRegistry.jsx";
import { serializeSubmitPayloadV3 } from "./SwmsFormV3Serializer";
import { saveSwmsForm } from "../../../../../../actions/v2/JobSwmsActions";
import { Strings } from "../../../../../../dataProvider/localize";
import SwmsResendConfirmModal from "../../JobSwmsTask/SwmsResendConfirmModal";
import VersionHistoryRecordsModal from "../VersionHistoryRecordsModal";

function JobSwmsFormV3Shell({ onClose, swmsData, handleSubmit, loading, change, jobId, swmsId, approvalSubmissionHistory, swmsTitle, swmsNumber }) {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [resendReviewer, setResendReviewer] = useState(null);
  const [versionHistory, setVersionHistory] = useState(null);

  const resolveTitle = (values) => {
    if (values && typeof values.title === "string" && values.title.trim() !== "") {
      return values.title.trim();
    }

    const projectDetailsTitle = values
      && values.sections
      && values.sections.document_project_details
      && values.sections.document_project_details.data
      && typeof values.sections.document_project_details.data.swms_name === "string"
      ? values.sections.document_project_details.data.swms_name
      : "";

    if (projectDetailsTitle && projectDetailsTitle.trim() !== "") {
      return projectDetailsTitle.trim();
    }

    return swmsData && typeof swmsData.title === "string" ? swmsData.title : "";
  };

  const onSubmit = (values) => {
    if (submitting) {
      return;
    }

    const submitPayload = serializeSubmitPayloadV3(values, swmsData || {});
    const formData = {
      title: resolveTitle(values),
      document: {
        meta: submitPayload && submitPayload.meta ? submitPayload.meta : (swmsData && swmsData.meta ? swmsData.meta : {}),
        sections: submitPayload && submitPayload.sections ? submitPayload.sections : {}
      }
    };

    setSubmitting(true);

    dispatch(saveSwmsForm(jobId, swmsId, formData))
      .then((message) => {
        setSubmitting(false);
        notification.success({
          message: Strings.success_title,
          description: message,
          className: "ant-success"
        });
        onClose();
      })
      .catch((err) => {
        console.log(err);
        setSubmitting(false);
        notification.error({
          message: Strings.error_title,
          description: err || Strings.generic_error,
          className: "ant-error"
        });
      });
  };

  return (
    <div className="container-fluid mb-5">
      <div className="row">
        <div className="col-12">
          <button
            className={`${styles.BlueTextButton} px-2 ${styles.PrimaryText}`}
            type="button"
            onClick={() => onClose(null)}
          >
            <KeyboardBackspace /> Back to SWMS
          </button>

          <form className="mt-3" onSubmit={handleSubmit(onSubmit)}>
            <JobSwmsFormV3SectionRegistry
              swmsData={swmsData}
              loading={loading}
              change={change}
              onResendReviewer={setResendReviewer}
              onVersionHistory={setVersionHistory}
              approvalSubmissionHistory={approvalSubmissionHistory}
            />

            <div className="mt-3 d-flex justify-content-end align-items-center" style={{ gap: "10px" }}>
              {submitting ? <CircularProgress size={18} /> : null}
              <button className={styles.OutlinedButton} type="button" onClick={() => onClose(null)}>
                Cancel
              </button>
              <button disabled={loading || submitting} className={styles.PrimaryButton} type="submit">
                Save SWMS
              </button>
            </div>
          </form>

          {resendReviewer && (
            <SwmsResendConfirmModal
              reviewer={resendReviewer}
              jobId={jobId}
              swmsId={swmsId}
              swmsName={swmsTitle}
              swmsNumber={swmsNumber}
              onClose={() => setResendReviewer(null)}
              onSuccess={() => { }}
            />
          )}

          {versionHistory && (
            <VersionHistoryRecordsModal
              versionHistory={versionHistory}
              jobId={jobId}
              swmsId={swmsId}
              swmsName={swmsTitle}
              swmsNumber={swmsNumber}
              version={versionHistory}
              onClose={() => setVersionHistory(null)}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default reduxForm({
  form: "job_swms_form_v3",
  enableReinitialize: true,
  destroyOnUnmount: true
})(JobSwmsFormV3Shell);

